export default {
	// pharma
	// specialty: {
	// 	en: 'Specialty',
	// 	ar: 'التخصص'
	// },

	// residentDoctors: {
	// 	en: 'Resident doctors',
	// 	ar: 'الأطباء المقيمين'
	// },
	// doctorHobbies: {
	// 	en: 'Customer hobbies',
	// 	ar: 'عادات الزبون '
	// 	// 'ar': 'عادات العميل'
	// },
	// pharmacyInfo: {
	// 	en: 'Pharmacy info',
	// 	ar: 'معلومات عن الصيدلي'
	// },
	// pharmacistInfo: {
	// 	en: 'Pharmacist info',
	// 	ar: 'معلومات عن الصيدليه'
	// },
	// nearbyPharmacy1: {
	// 	en: 'Nearby pharmacy 1',
	// 	ar: 'أقرب نقطة بيع(1)',
	// },
	// nearbyPharmacy2: {
	// 	en: 'Nearby pharmacy 2',
	// 	ar: 'أقرب نقطة بيع(2)',
	// },

	// sales
	specialty: {
		en: 'Core Business',
		ar: 'النشاط الأساسي'
	},
	residentDoctors: {
		en: 'The employees present',
		ar: 'الموظفين المتواجدين'
	},

	doctorHobbies: {
		en: 'Customer hobbies',
		ar: 'عادات الزبون '
	},

	pharmacyInfo: {
		en: 'Company info',
		ar: 'معلومات عن الشركة'
	},

	pharmacistInfo: {
		en: 'Customer info',
		ar: 'معلومات عن الزبون'
	},

	nearbyPharmacy1: {
		en: 'Near by markets 1',
		ar: 'أقرب نقطة بيع (1)',
	},

	nearbyPharmacy2: {
		en: 'Near by markets 2',
		ar: 'أقرب نقطة بيع (2)',
	}
}
